import {IntermediatePart} from "../../intermediatePart";
import {ShowerAccessories} from "../../parts/showerAccessories";
import {Shower} from "../../parts/shower";
import {IS_BATHROOM_OLD_BV_SCENE} from "../../../../../config";

export default class BackgroundBG extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'background_bg';
    this.partName = 'Background BG';
    this.windowNeededLayouts = [1];
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BackgroundBG());
  }

  getArrayOfConditions() {
    const layout = this.getParent().layout;
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerAccessoriesParent = layout.parts[ShowerAccessories.id];
    const showerParent = layout.parts[Shower.id];

    const windowBody = showerAccessoriesParent.windowBody;
    if (windowBody && this.windowNeededLayouts.includes(layout.type) && document.kvConfig.toolVersion !== 5) {
      conditions.push({
        propName: "Window",
        propValue: (windowBody && windowBody.activeFeature && windowBody.disabled) ? "Off" : "On"
      })
    }

    if (showerParent && showerParent.showerSize() && !IS_BATHROOM_OLD_BV_SCENE) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerParent.showerSize()
      })
    }

    return conditions
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Background.BackgroundBG;
    }
  }
}
